/**
 * Rôle : Container SideBarre
 * Copyright: © 2021 Remote Monkey S.A.S.U http://remote-monkey.fr
 */
import React from 'react';

export default function ContentRight(props) {
	const { children } = props;

	return <div className="pl-0 lg:pl-5 w-full">{children}</div>;
}
